module.exports = __webpack_public_path__ + "static/media/left-arrow-white.78d2e6b0.svg";